"use client";

import { c as _c } from "react/compiler-runtime";
import { useClient } from "@repo/design-system/utils/client/client";
import { usePathname } from "next/navigation";
import { env } from "~/setup/env";
import { GTMScript } from "./gtm-script-eon";
import { LinkedInConversions } from "./linkedin-conversions-eon";
import { MetaConversions } from "./meta-conversions-eon";
import { UserCentrics } from "./usercentrics";
import EyeAbleScript from "./eye-able-script";
export default function Scripts() {
  const $ = _c(8);
  const pathname = usePathname();
  const client = useClient();
  const isWidgetPage = pathname?.includes("/widgets");
  if (isWidgetPage) {
    return null;
  }
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = env.ENVIRONMENT !== "development" && <GTMScript />;
    t1 = env.ENVIRONMENT !== "development" && <LinkedInConversions />;
    t2 = env.ENVIRONMENT !== "development" && <MetaConversions />;
    t3 = <UserCentrics />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== client) {
    t4 = env.ENVIRONMENT !== "development" && client === "eon" && <EyeAbleScript />;
    $[4] = client;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <>{t0}{t1}{t2}{t3}{t4}</>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}